<main role="main" class="not-home-page">
    <div class="row">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="banner"><img src="" alt="" /></div>
            <app-breadcrumb></app-breadcrumb>
            <h2>{{ description?.Title }}</h2>
          </div>
        </div>
        <div>
          <div class="row">
            <div class="col-lg-3 col-md-3 col-s-12">
              <nav id="sidebar">
                <app-statique-menu [lg]="outputLg" [cururl]="currentUrl"></app-statique-menu>
              </nav>
            </div>
            <div class="col-lg-9 col-md-9 col-s-12">
                <p class="text-primary size18 font-weight-semibold">
                    {{ description?.Contenu }}
                  </p>
                  <table id="offres" class="table table-striped table-bordered" style="width:100%">
                    <thead>
                        <tr>
                            <th>Programme</th>
                            <th>Région</th>
                            <th>Télécharger</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let p of dataprogrammes">
                            <td>{{p.ObjetAppelOffre}}</td>
                            <td>{{getRegion(p.RegionId)}}</td>
                            <td><a href="{{p.AttachmentFiles[0].ServerRelativeUrl}}">Telecharger</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
      </div>
    </div>
  </div>
</main>